import 'babel-polyfill'; // polyfill for all ES2015+ features, must be imported in root file
// This has to be before loadComponents to ensure styles in react components,
// overrides the more generic styles
import './styles/globals.less';
import React from 'react';
import { render } from 'react-dom';
import { loadComponents } from './routes';
import StandaloneApp from './StandaloneApp';
import { setupBrowserAuthLogoutLinks } from './utils/browserAuthLogout';
import { getSentry } from './utils/sentry';
var currentUri = document.location.pathname;
try {
    getSentry();
}
catch (err) {
    console.error('Failed to initialize Sentry!', err);
}
document.addEventListener('DOMContentLoaded', function () {
    setupBrowserAuthLogoutLinks();
    var standaloneRoot = document.getElementById('standaloneReactRoot');
    if (standaloneRoot) {
        render(React.createElement(StandaloneApp, null), standaloneRoot);
        return;
    }
    loadComponents(currentUri);
});
